import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { loadTicketImage, TicketAttachment } from '../../utils/ticketsApi';

const TicketImage: React.FC<{ ticketId: number; file: TicketAttachment; onImageLoad: () => void }> = ({ ticketId, file, onImageLoad }) => {
  const [url, setUrl] = useState('');
  const [error, setError] = useState(false);
  const [visible, setVisible] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const container = useRef<HTMLDivElement>(null);
  const closeButton = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!container.current || typeof IntersectionObserver === 'undefined') { setVisible(true); return; }
    const observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) { setVisible(true); observer.disconnect(); } }, { rootMargin: '150px' });
    observer.observe(container.current);
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    if (!visible) return;
    const controller = new AbortController();
    let objectUrl = '';
    setError(false); setUrl('');
    void loadTicketImage(ticketId, file.id, controller.signal).then(blob => {
      if (controller.signal.aborted) return;
      objectUrl = URL.createObjectURL(blob); setUrl(objectUrl);
    }).catch(() => { if (!controller.signal.aborted) setError(true); });
    return () => { controller.abort(); if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [visible, ticketId, file.id, attempt]);
  useEffect(() => {
    if (!expanded) return;
    const previous = document.activeElement as HTMLElement | null;
    closeButton.current?.focus();
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') { event.stopPropagation(); setExpanded(false); }
      if (event.key === 'Tab') { event.preventDefault(); closeButton.current?.focus(); }
    };
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('keydown', onKey); previous?.focus(); };
  }, [expanded]);
  return <div ref={container} className="ticket-image">
    {error ? <div className="ticket-image__status">Не удалось открыть изображение.<button type="button" className="ui-btn ui-btn--outline ui-btn--sm" onClick={() => setAttempt(value => value + 1)}>Повторить</button></div> : !url ? <div className="ticket-image__status">Загрузка изображения…</div> : <button type="button" className="ticket-image__open" aria-label={`Открыть изображение: ${file.name}`} onClick={() => setExpanded(true)}><img src={url} alt={file.name} onLoad={onImageLoad} onError={() => setError(true)} /><span>{file.name} · Нажмите, чтобы увеличить</span></button>}
    {expanded && url && createPortal(<div className="ticket-lightbox" role="dialog" aria-modal="true" aria-label="Просмотр изображения"><div className="ticket-lightbox__backdrop" onClick={() => setExpanded(false)} /><div className="ticket-lightbox__content"><button ref={closeButton} type="button" aria-label="Закрыть изображение" onClick={() => setExpanded(false)}>×</button><img src={url} alt={file.name} /></div></div>, document.body)}
  </div>;
};
export default TicketImage;
